import { safeDeleteSheet } from "@/lib/office-helpers";

const HOURS_ROWS = [
  ["emilio", 1, 8, 8, 7, 6, 9],
  ["evan", 2, 10, 10, 10, 10, 10],
  ["tyler", 3, 5, 3, 8, 4, 4],
  ["clyde", 4, 9, 8.5, 9, 8, 8],
  ["arturro", 5, 8, 8, 8, 8, 8],
  ["cid", 6, 7, 9, 9, 6, 10],
  ["leon", 7, 8, 8, 8, 8, 8],
  ["james", 8, 3.5, 8, 7, 7.5, 9],
  ["carl", 9, 10, 9, 9, 7, 2],
  ["steven", 10, 1, 9, 6, 8, 8],
  ["michael", 11, 4, 4, 3, 8, 7],
  ["patricia", 12, 6, 6, 5, 8, 4],
  ["jaques", 13, 8, 8, 8, 8, 8],
];

const CALL_ROWS = [
  ["Emilio", "10:32", "06:30", "06:42", "08:40", "03:15"],
  ["Evan", "03:00", "04:13", "04:00", "03:45", "05:04"],
  ["Tyler", "09:03", "08:17", "07:29", "08:43", "06:15"],
  ["Clyde", "04:22", "03:57", "05:07", "04:16", "07:23"],
  ["Arturro", "02:12", "05:36", "03:33", "06:14", "05:12"],
  ["Cid", "03:15", "02:45", "03:44", "04:01", "03:27"],
  ["Leon", "04:41", "11:13", "09:22", "05:15", "06:21"],
  ["James", "06:22", "09:41", "04:15", "13:49", "07:01"],
  ["Carl", "21:18", "04:12", "04:35", "03:45", "05:24"],
  ["Steven", "08:13", "07:40", "03:55", "06:32", "06:35"],
  ["Michael", "05:12", "05:15", "05:40", "05:03", "05:59"],
  ["Patricia", "06:12", "07:16", "05:58", "06:34", "07:01"],
  ["Jaques", "02:49", "05:01", "04:35", "05:33", "04:17"],
];

function timeToExcel(text: string): number {
  const [m, s] = text.split(":").map(Number);
  return (m * 60 + s) / 86400;
}

export async function startProject23(): Promise<void> {
  await Excel.run(async (context) => {
    await safeDeleteSheet(context, "Horas de empleados");
    await safeDeleteSheet(context, "Tiempo promedio de llamada");

    const hours = context.workbook.worksheets.add("Horas de empleados");
    const calls = context.workbook.worksheets.add("Tiempo promedio de llamada");

    hours.getRange("A1:J1").merge();
    hours.getRange("A1").values = [["Ayuda tecnológica"]];
    hours.getRange("A1").format.font.size = 28;
    hours.getRange("A1").format.font.bold = true;
    hours.getRange("A2:J2").merge();
    hours.getRange("A2").values = [["Horario del empleado"]];
    hours.getRange("A2").format.font.bold = true;
    hours.getRange("A2").format.horizontalAlignment = "Center";

    const hoursTable = hours.tables.add("A3:J3", true);
    hoursTable.name = "HorasEmpleados";
    hoursTable.getHeaderRowRange().values = [[
      "Empleado",
      "Estación",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Horas extra",
      "Nombre",
      "Total de horas",
    ]];
    hoursTable.rows.add(
      undefined,
      HOURS_ROWS.map((row, index) => {
        const total =
          Number(row[2]) + Number(row[3]) + Number(row[4]) + Number(row[5]) + Number(row[6]);
        return [...row, "", "", total];
      }),
    );
    hoursTable.style = "TableStyleMedium2";
    hours.getRange("J4:J16").numberFormat = Array(HOURS_ROWS.length).fill(["0.0"]);
    hours.getRange("A20:B22").values = [
      ["40-49 horas", "150%"],
      ["50-59 horas", "200%"],
      ["60+ horas", "250%"],
    ];

    calls.getRange("A1:G1").merge();
    calls.getRange("A1").values = [["Ayuda tecnológica"]];
    calls.getRange("A1").format.font.size = 28;
    calls.getRange("A1").format.font.bold = true;
    calls.getRange("A2:G2").merge();
    calls.getRange("A2").values = [["Tiempo promedio de llamada (mm:ss)"]];
    calls.getRange("A2").format.font.bold = true;
    calls.getRange("A2").format.horizontalAlignment = "Center";

    const callsTable = calls.tables.add("A3:G3", true);
    callsTable.name = "TiempoLlamada";
    callsTable.getHeaderRowRange().values = [[
      "Vendedor",
      "Lun",
      "Mar",
      "Mié",
      "Jue",
      "Vie",
      "Tendencia",
    ]];
    callsTable.rows.add(
      undefined,
      CALL_ROWS.map((row) => [
        row[0],
        timeToExcel(row[1]),
        timeToExcel(row[2]),
        timeToExcel(row[3]),
        timeToExcel(row[4]),
        timeToExcel(row[5]),
        "",
      ]),
    );
    callsTable.style = "TableStyleMedium2";
    calls.getRange("B4:F16").numberFormat = Array(CALL_ROWS.length).fill([
      "mm:ss",
      "mm:ss",
      "mm:ss",
      "mm:ss",
      "mm:ss",
    ]);

    hours.activate();
    hours.getRange("A1").select();
    await context.sync();
  });
}
